<template lang="pug">
#annModal.modal.fade(tabindex='-1' aria-hidden='true')
  .modal-dialog.modal-ann.modal-dialog-centered
    .modal-content
      .annbox
        .cclose(data-bs-dismiss='modal')
          img(src='/new/img/ann/close.png')
        .ccon(v-if="paginatedItems.length > 0")
          .anncon
            .nav.nav-pills(role='tablist' aria-orientation='vertical')
              button.nav-link(:class="{'active' : index === 0}" v-for="(ann, index) in paginatedItems" data-bs-toggle='pill' :data-bs-target="'#vann'+index" type='button' @click="getDetails(index)")
                p(v-if="getLanguage==='en'" v-html="ann.en_title")
                p(v-if="getLanguage==='my'" v-html="ann.mys_title == null ? ann.en_title : ann.mys_title")
                p(v-if="getLanguage==='zh'" v-html="ann.cn_title == null ? ann.en_title : ann.cn_title")
            .tab-content
              .tab-pane.fade(:id="'vann'+index" role='tabpanel' :class="{'show active' : index === 0}" v-for="(ann, index) in paginatedItems")
                template(v-if="getLanguage==='en'")
                  h5.m-0.text-white(v-html="ann.en_title")
                  img.annimg.pointer(:src='imgUrl+ann.en_background_url' @click="btnAction")
                template(v-if="getLanguage==='my'")
                  h5.m-0.text-white(v-html="ann.mys_title == null ? ann.en_title : ann.mys_title")
                  img.annimg.pointer(:src='ann.mys_background_url == null ? imgUrl+ann.en_background_url : imgUrl+ann.mys_background_url' @click="btnAction")
                template(v-if="getLanguage==='zh'")
                  h5.m-0.text-white(v-html="ann.cn_title == null ? ann.en_title : ann.cn_title")
                  img.annimg.pointer(:src='ann.cn_background_url == null ? imgUrl+ann.en_background_url : imgUrl+ann.cn_background_url' @click="btnAction")
          .annpagi
            .pitem(v-for="page in totalPages" @click="goToPage(page)" :class="{ active: page === currentPage }") {{ page }}
        .ccon(v-else)
          .d-flex.justify-content-center.align-items-center.flex-column.text-center.text-white.h-100
            i.fa-regular.fa-newspaper.display-6
            div.text-uppercase No data
        .bbg
          img.des(src='/new/img/ann/ann-bg.png')
          img.mob(src='/new/img/ann/ann-mbg.png')
        //- .agreewrap.invisible
          .agreebox(v-if="paginatedItems.length > 0" @click="btnAction") {{defaultText}}
          .agreebox(v-else @click="$helpers.closeModal('#annModal')") {{ $t('ui.close') }}
//- div
  #modal-banner.modal.show(tabindex='-1' role='dialog')
    .modal-dialog.modal-dialog-centered.modal-form(role='document')
      .modal-content
        .position-absolute.close-button.pointer(@click="$helpers.closeModal('#modal-banner')")
          i.fa-solid.fa-x.fa-2x
        .modal-body
          template(v-if="!isLoggedIn")
            #carouselAnnBeforeLog.carousel.slide(data-bs-ride='carousel')
              .carousel-inner
                .carousel-item(:class="{'active' : index === 0}" v-for="(ann, index) in getAnnBeforeLog")
                  template(v-if="getLanguage==='en'")
                    img.img-fluid(:src='imgUrl+ann.en_background_url' )
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.en_title")
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.en_body")
                    .btn-wrapper.justify-content-center
                      .btn-modal-banner.btn-popup.pointer(v-if="ann.en_btn === null" @click="clickAction(ann.target_window, ann.btn_href)") {{$t('ui.ok')}}
                      .btn-modal-banner.btn-popup.pointer(v-else @click="clickAction(ann.target_window, ann.btn_href)") {{ann.en_btn}}
                  template(v-else)
                    img.img-fluid(:src='imgUrl+ann.fil_background_url' )
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.fil_title")
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.fil_body")
                    .btn-wrapper.justify-content-center
                      .btn-modal-banner.btn-popup.pointer(v-if="ann.fil_btn === null" @click="clickAction(ann.target_window, ann.btn_href)") {{$t('ui.ok')}}
                      .btn-modal-banner.btn-popup.pointer(v-else @click="clickAction(ann.target_window, ann.btn_href)") {{ann.fil_btn}}
            button.carousel-control-prev(v-if="getAnnBeforeLog.length>1" type='button' data-bs-target='#carouselAnnBeforeLog' data-bs-slide='prev')
              span.carousel-control-prev-icon(aria-hidden='true')
              span.visually-hidden Previous
            button.carousel-control-next(v-if="getAnnBeforeLog.length>1" type='button' data-bs-target='#carouselAnnBeforeLog' data-bs-slide='next')
              span.carousel-control-next-icon(aria-hidden='true')
              span.visually-hidden Next
          template(v-else)
            #carouselAnnAfterLog.carousel.slide(data-bs-ride='carousel')
              .carousel-inner
                .carousel-item(:class="{'active' : index === 0}" v-for="(ann, index) in getAnnAfterLog")
                  template(v-if="getLanguage==='en'")
                    img.img-fluid(:src='imgUrl+ann.en_background_url' )
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.en_title")
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.en_body")
                    .btn-wrapper.justify-content-center
                      .btn-modal-banner.btn-popup.pointer(v-if="ann.en_btn === null" @click="clickAction(ann.target_window, ann.btn_href)") {{$t('ui.ok')}}
                      .btn-modal-banner.btn-popup.pointer(v-else @click="clickAction(ann.target_window, ann.btn_href)") {{ann.en_btn}}
                  template(v-else)
                    img.img-fluid(:src='imgUrl+ann.fil_background_url' )
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.fil_title")
                    .btn-wrapper.justify-content-center
                      div.content(v-html="ann.fil_body")
                    .btn-wrapper.justify-content-center
                      .btn-modal-banner.btn-popup.pointer(v-if="ann.fil_btn === null" @click="clickAction(ann.target_window, ann.btn_href)") {{$t('ui.ok')}}
                      .btn-modal-banner.btn-popup.pointer(v-else @click="clickAction(ann.target_window, ann.btn_href)") {{ann.fil_btn}}
            button.carousel-control-prev(v-if="getAnnAfterLog.length>1" type='button' data-bs-target='#carouselAnnAfterLog' data-bs-slide='prev')
              span.carousel-control-prev-icon(aria-hidden='true')
              span.visually-hidden Previous
            button.carousel-control-next(v-if="getAnnAfterLog.length>1" type='button' data-bs-target='#carouselAnnAfterLog' data-bs-slide='next')
              span.carousel-control-next-icon(aria-hidden='true')
              span.visually-hidden Next
</template>
<script>
import config from "@/config";
export default {
  data(){
    return{
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      imgUrl: config.imageUrl,
      bannerSelected: 0,
      defaultText: "",
      currentPage: 1,
      itemsPerPage: 5
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getAnnBeforeLog(){
      return this.$store.state.user.annBeforeLog
    },
    getAnnAfterLog(){
      return this.$store.state.user.annAfterLog
    },
    totalPages(){
      if(this.isLoggedIn){
        return Math.ceil(this.getAnnAfterLog.length / this.itemsPerPage);
      }else{
        return Math.ceil(this.getAnnBeforeLog.length / this.itemsPerPage);
      }
    },
    paginatedItems(){
      if(this.isLoggedIn){
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.getAnnAfterLog.slice(start, end);
      }else{
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.getAnnBeforeLog.slice(start, end);
      }
      
    },
  },
  watch:{
    getAnnBeforeLog(newData){
      this.getDetails(0, newData)
    },
    getAnnAfterLog(newData){
      this.getDetails(0, newData)
    },
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.dismiss()
      }
    }
  },
  
  destroyed(){
    this.annBeforeLog = []
    this.annAfterLog = []
  },
  created(){
  },
  mounted(){
  },
  methods:{
    goToPage(page) {
      this.currentPage = page;
      $('.nav-link').removeClass('active');
      // $("#vann0").removeClass("show active")
      // $("#vann1").removeClass("show active")
      // $("#vann2").removeClass("show active")
      // $("#vann3").removeClass("show active")
      // $("#vann4").removeClass("show active")
      $("[id^=vann]").removeClass("show active")
      $('.nav-link:first').addClass('active');
      $("#vann0").addClass("show active")
      if(page === 0){
        this.getDetails(0)
      }else{
        this.getDetails((page-1)*5)
      }
    },
    getDetails(target, data){
      this.bannerSelected = target
      if(this.isLoggedIn){
        if(data){
          if(this.getLanguage==='en'){
            this.defaultText = data[target].en_btn === null ? "OK" : data[target].en_btn
          }else{
            this.defaultText = data[target].fil_btn === null ? "OK" : data[target].fil_btn
          }
        }else{
          if(this.getLanguage==='en'){
            this.defaultText = this.getAnnAfterLog[target].en_btn === null ? "OK" : this.getAnnAfterLog[target].en_btn
          }else{
            this.defaultText = this.getAnnAfterLog[target].fil_btn === null ? "OK" : this.getAnnAfterLog[target].fil_btn
          }
        }
      }else{
        if(data){
          if(this.getLanguage==='en'){
            this.defaultText = data[target].en_btn === null ? "OK" : data[target].en_btn
          }else{
            this.defaultText = data[target].fil_btn === null ? "OK" : data[target].fil_btn
          }
        }else{
          if(this.getLanguage==='en'){
            this.defaultText = this.getAnnBeforeLog[target].en_btn === null ? "OK" : this.getAnnBeforeLog[target].en_btn
          }else{
            this.defaultText = this.getAnnBeforeLog[target].fil_btn === null ? "OK" : this.getAnnBeforeLog[target].fil_btn
          }
        }
      }
    },
    btnAction(){
      // console.log(this.bannerSelected)
      if(this.isLoggedIn){
        if(this.getAnnAfterLog.length > 0){
          if(this.getAnnAfterLog[this.bannerSelected].btn_href === null){
            this.dismiss()
          }else{
            if(this.getAnnAfterLog[this.bannerSelected].target_window === "_blank"){
              setTimeout(() => {
                window.open(this.getAnnAfterLog[this.bannerSelected].btn_href, this.getAnnAfterLog[this.bannerSelected].target_window)
              }) 
            }else{
              if(this.getAnnAfterLog[this.bannerSelected].btn_href!==''){
                var temp = this.getAnnAfterLog[this.bannerSelected].btn_href.split(":");
                if(temp.length > 1 ){
                  this.$router.push({name:temp[0],params:{"target": [temp[1]]}}).catch(error =>{})
                }else{
                  this.$router.push("/"+this.getAnnAfterLog[this.bannerSelected].btn_href).catch(error =>{})
                }
              }else{
              }
              this.dismiss()
            }
          }
        }
      }else{
        if(this.getAnnBeforeLog.length > 0){
          if(this.getAnnBeforeLog[this.bannerSelected].btn_href === null){
            this.dismiss()
          }else{
            if(this.getAnnBeforeLog[this.bannerSelected].target_window === "_blank"){
              setTimeout(() => {
                window.open(this.getAnnBeforeLog[this.bannerSelected].btn_href, this.getAnnBeforeLog[this.bannerSelected].target_window)
              }) 
            }else{
              this.$router.push("/"+this.getAnnBeforeLog[this.bannerSelected].btn_href).catch(error =>{})
              this.dismiss()
            }
          }
        }
      }
    },
    dismiss(){
      $("#annModal").modal("hide");
    },
    // clickAction(target, link){
    //   if(link===null){
    //     this.dismiss()
    //   }else{
    //     if(target === "_blank"){
    //       setTimeout(() => {
    //         window.open(link, target)
    //       }) 
    //     }else{
    //       this.$router.push("/"+link).catch(error =>{})
    //       this.dismiss()
    //     }
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.carousel-control-next, .carousel-control-prev{
  top: auto !important;
  bottom: 10px !important;
}
#annModal{
  z-index: 999999;
}
</style>